<template>
  <div id='login'>
    <div id="login-from">
      <transition name="bounce">
        <div v-if="show">
          <img src="../assets/img/logo.png" id="login-wrapper" />
          <el-input type="text" placeholder="请输入账号" prefix-icon="fa fa-user-o" v-model="info.username" name="userid" @keyup.enter.native="listenEnter">
          </el-input>
          <label v-show="nameMsg!=''" class="warning">{{nameMsg}}</label>
          <el-input type="password" placeholder="请输入密码" prefix-icon="fa fa-lock" v-model="info.password" name="password" @keyup.enter.native="listenEnter">
          </el-input>
          <label v-show="passwordMsg!=''" class="warning">{{passwordMsg}}</label>
          <br>
          <el-button @click="check" class="btn btn-success pull-right">登陆</el-button>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data: function() {
    return {
      info: {
        username: "",
        password: ""
      },
      show: false,
      nameMsg: "",
      passwordMsg: "",
    };
  },
  mounted: function() {
    this.change();
  },
  methods: {
    change: function() {
      this.show = !this.show;
    },
    check: function() {
      var isLogin = true;
      this.nameMsg = "";
      this.passwordMsg = "";
      if (this.info.username.length < 2) {
        isLogin = false;
        this.nameMsg = "账号不能小于2位";
      }
      if (this.info.password.length < 6) {
        this.passwordMsg = "密码不能小于6位";
        isLogin = false;
      }
      if (isLogin) {
        this.submit();
      }
    },
    listenEnter: function() {
      this.check();
    },
    submit: async function() {
      var result = await this.$doPost("/api/login", this.info);
      if (result.msgCode === 0) {
        // console.log(result.result)

        //用path不能传params
        // this.$router.push({ name: "Home", params: {loginRes: result.result}});
        this.$router.push({ name: "Main" });

        // window.location.href="/"
      } else {
        this.nameMsg = result.msg;
      }
    }
  }
};
</script>

<style scoped>
#login {
  height: 100vh;
  width: 100vw;
  background-color: #00b0f0;
  text-align: center;
}

#login-from {
  width: 300px;
  height: 150px;
  position: fixed;
  top: 20%;
  left: 0;
  right: 0;
  margin: 0 auto;
}

.el-input {
  margin: 10px;
}


.bounce-enter-active {
  animation: bounce-in 0.5s;
}

.bounce-leave-active {
  animation: bounce-in 0.5s reverse;
}

@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}

.warning {
  font-size: 6px;
  color: rgba(161, 17, 17, 0.925);
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue